import {Injectable, NgZone} from '@angular/core';
import {Location} from '@angular/common';
import {AbstractControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApiToolsService} from './api-tools.service';
import {ConfirmDialogService} from './confirm-dialog.service';
import {DataToolsService} from './data-tools.service';
import {filter, map, switchMap, take} from 'rxjs/operators';
import {cloneDeep} from "lodash";
import {Adresse} from "../Models/Adresse";
import {loadStripe} from "@stripe/stripe-js";
import {environment} from "../../environments/environment";
import {settings} from "../const/settings";
import {AuthService} from "./auth.service";
import {ROUTES_PATHS} from "../const/routes";
import {RENOVATION_MAP, RENOVATION_VALUE_MAP, RenovationKey} from "../const/renovation-type";
import {TableBoName} from "../enums/table-bo-name.enum";
import {SiteKeyEnum} from "../enums/site-key.enum";
import {CodePermissionEnum} from "../enums/code-permission.enum";

declare var $: any;

@Injectable({
	providedIn: 'root'
})
export class SharedToolsService {
	filter = filter;
	stripePromise = loadStripe(environment.stripePublishableKey);
	private settingsSubject = new BehaviorSubject<any>(settings);
	settings$ = this.settingsSubject.asObservable();

	constructor(
		public location: Location,
		public router: Router,
		private http: HttpClient,
		private ngZone: NgZone,
		public apiToolsService: ApiToolsService,
		public confirmDialogService: ConfirmDialogService,
		public dataToolsService: DataToolsService,
		private authService: AuthService,
	) {
	}

	isNullOrUndefined(value: any): value is null | undefined {
		return value === null || value === undefined;
	}

	closeModal(_modalInfo: any) {
		_modalInfo.noFn();
	}

	getJSON(nameJson: string): Observable<any> {
		//console.log(nameJson, this.http.get("./assets/json/" + nameJson + ".json"))
		return this.http.get("./assets/json/" + nameJson + ".json");
	}

	loadTexts(nameJson: string): Observable<any> {
		return this.getJSON(nameJson).pipe(
			map((resp: any) => resp.data)
		);
	}

	getUsrByID() {
		this.apiToolsService.getUserID().subscribe(
			(res: any) => {
				console.log("res getUserID ==> ", res);
				if (res) {
					//localStorage.setItem('USER', JSON.stringify(res));
				}
			}, err => {
				console.log('ERR getUserID ==> ', err);
			}
		)
	}

	stringToArray(_string: any, _sep: any) {
		const arrItems = _string.split(_sep);
		console.log("v stringToArray ==> ", arrItems);
		return arrItems;
	}

	goTo(path: any, objParams: any) {
		console.log("path", path);
		//console.log("objParams", objParams);
		this.router.navigate([path], {
			queryParams: objParams
		});
	}

	getRoutePath(key: string): string {
		return ROUTES_PATHS[key as keyof typeof ROUTES_PATHS];
	}

	linksMenuGoTo(_item: any) {
		console.log("linksMenuGoTo → ", _item);
		let itemPath = _item.path;

		let modalTxt: any;
		this.getModalTexts().subscribe(modalsTxt => {
			modalTxt = cloneDeep(modalsTxt);
			console.log(modalTxt);

			if (_item.label === "Déconnexion") {
				console.log("this.returnObjectSwitchRefId()", this.returnObjectSwitchRefId());

				this.confirmDialogService.confirmThis("", modalTxt?.modalDeconnect, "confirm", "", () => {
					console.log("Yes clicked");

					if (this.returnObjectSwitchRefId() == SiteKeyEnum.LADRESSE || this.returnObjectSwitchRefId() == SiteKeyEnum.LOISELETDAIGREMONT) {
						this.getParamSettings('back_url').subscribe((url: string) => {
							console.log("getParamSettings back_url ==> ", url);

							localStorage.clear();
							location.href = url;
						});

						return;
					}

					this.authService.triggerLogout();

				}, () => {
					console.log("No clicked");
				});
			} else if (itemPath === ROUTES_PATHS.WELCOME) {
				if (localStorage.getItem('BATIMENT') || localStorage.getItem('currentPresta')) {
					this.confirmDialogService.confirmThis("", modalTxt?.modalSimulationEnCours, "confirm", "", () => {
						console.log("Yes clicked");
						if (localStorage.getItem('BATIMENT')) localStorage.removeItem('BATIMENT');
						if (localStorage.getItem('arrDmgByPiece')) localStorage.removeItem('arrDmgByPiece');
						if (localStorage.getItem('currentPresta')) localStorage.removeItem('currentPresta');
						if (localStorage.getItem('arrPieces')) localStorage.removeItem('arrPieces');
						if (localStorage.getItem('RENOVATION')) localStorage.removeItem('RENOVATION');
						if (localStorage.getItem('modalInfo')) localStorage.removeItem('modalInfo');
						this.router.navigate(['/' + itemPath]);
					}, () => {
						console.log("No clicked");
					});
				} else {
					this.router.navigate(['/' + itemPath]);
				}
			} else {
				this.router.navigate(['/' + itemPath]);
			}
		});
	}

	getGlobalTexts() {
		this.getJSON('txtGlobal').subscribe(respGlb => {
			console.log("respGlb ==> ", respGlb.data);

			this.dataToolsService.setGlobalTexts(respGlb.data);
		})
	}

	getGlobalTextsObs(): Observable<any> {
		return this.getJSON('txtGlobal').pipe(
			map(respGlb => respGlb.data)
		);
	}

	getModalTexts(): Observable<any> {
		return new Observable(observer => {
			this.getJSON('txtModals').subscribe(respMod => {
				observer.next(respMod.data);
				observer.complete();
			}, error => {
				observer.error(error);
			});
		});
	}

	getModalTextsForModalComponent(): Observable<any> {
		return new Observable(observer => {
			this.getJSON('txtModals').subscribe(respMod => {
				observer.next(respMod);
				observer.complete();
			}, error => {
				observer.error(error);
			});
		});
	}

	getLabelByIdSwitchString(id: number, array: any, field: string) {
		let idKey = '';
		let labelKey = '';

		switch (field) {
			case 'ETS_ID':
				idKey = 'ETS_ID';
				labelKey = 'ETS_LIBELLE';
				break;
			default:
				idKey = 'id';
				labelKey = 'label';
				break;
		}

		let libelle = array.filter((item: any) => {
			return (item[idKey] == id);
		});

		return (!libelle[0]) ? "" : libelle[0][labelKey];
	}

	getColorById(id: number, array: any, idKey: string) {
		let color = "";
		array.forEach((item: any) => {
			if (item[idKey] == id) {
				switch (item[idKey]) {
					case -1: //En cours de saisie
						color = "color-default";
						break;
					case 2: //En attente de validation
					case 7: //En attente de validation - escaladée
						color = "color-grey-blue";
						break;
					case 1: //Terminée
					case 3: //Acceptée
					case 5: //Escaladée
						color = "color-green";
						break;
					case 4: //Refusée
					case 6: //Supprimée
						color = "color-red";
						break;
				}
			}
		});
		return color;
	}

	getPaginationLabels(value: string) {
		let label = "";
		this.dataToolsService.currentGlobalTexts.subscribe(object => {
			//console.log("object ==> ", object);
			let obj: any = object;
			label = obj?.pagination[value] ?? "";

			return label;
		})
		return label;
	}

	initTabOptions(_tabType: any = "") {
		let sortKey: string;
		switch (_tabType) {
			case TableBoName.AGENCIES:
				sortKey = 'ORG_ID';
				break;
			case TableBoName.USERS:
				sortKey = 'USR_ID';
				break;
			case TableBoName.ESTIMATIONS:
				sortKey = 'SIN_ID';
				break;
			default:
				sortKey = 'id';
				break;
		}
		return {p: 1, itemsPerPage: 10, sortKey: sortKey, sortOrder: 'asc'};
	}

	searchInTable(_searchTerm: any, _originalArray: any, _arrayToGetLabel: any[] = [], colsToSearch: any = []) {
		//console.log("_searchTerm", _searchTerm);
		let _array: any = [];
		_array = _originalArray.filter((item: any) =>
			Object.entries(item).some(([key, val]: [string, any]) => {
				if (val === null) return false;

				// Check if the key is in the table as a column
				let isKeiInTable = false;
				if (colsToSearch.length > 0) {
					isKeiInTable = colsToSearch.filter((col: any) => col.key === key).length > 0;
				}
				if (!isKeiInTable) return false;

				if (val instanceof Date) {
					// If the value is a date, convert it to a string format 'dd/MM/yyyy'
					const dateStr = val.toLocaleDateString('fr-FR'); // Convertit la date en format 'dd/MM/yyyy'
					return dateStr.includes(_searchTerm);
				} else if (typeof val === 'number') {
					// If the value is a number and the array to get the label is empty, return the value
					if (_arrayToGetLabel.length === 0)
						return val.toString().toLowerCase().includes(_searchTerm.toLowerCase());
					// If the value is a number and the array to get the label is not empty
					// ==> Search for the label in the array
					const label = this.getLabelByIdSwitchString(val, _arrayToGetLabel, 'ETS_ID');
					if (label) return label.toLowerCase().includes(_searchTerm.toLowerCase());
					else return val.toString().toLowerCase().includes(_searchTerm.toLowerCase());
				} else if (typeof val === 'object' && val !== null) {
					if (val.hasOwnProperty('ORG_LIBELLE')) {
						return val.ORG_LIBELLE.toLowerCase().includes(_searchTerm.toLowerCase());
					}
				} else if (Array.isArray(val)) { // Utilisé ?
					// Check if the array is not empty
					if (val.length > 0) {
						// Convert the search term to lower case
						_searchTerm = _searchTerm.toLowerCase();
						// Filter the array
						let result = val.filter((item: any) => {
							// Ensure the item has the properties 'USR_NOM' and 'USR_PRENOM'
							if (item.hasOwnProperty('USR_NOM') && item.hasOwnProperty('USR_PRENOM')) {
								let nom = item.USR_NOM.toLowerCase();
								let prenom = item.USR_PRENOM.toLowerCase();
								return nom.includes(_searchTerm) || prenom.includes(_searchTerm);
							}

							// Ensure the item has the property 'agencyName'
							if (item.hasOwnProperty('agencyName')) {
								let agencyName = item.agencyName.toLowerCase();
								return agencyName.includes(_searchTerm);
							}

							return false;
						});

						// If the result array is not empty, return true
						if (result.length > 0) {
							return true;
						}
					}
				} else {
					return val.toString().toLowerCase().includes(_searchTerm.toLowerCase());
				}
			})
		);
		//console.log("_arrayToReturn", _array);
		return _array;
	}

	sortTable(key: string, array: any, sort_options: any) {
		let order = sort_options.sortOrder;

		if (key === 'actions') return;

		// Inverse l'ordre de tri
		order = order === 'asc' ? 'desc' : 'asc';
		sort_options.sortOrder = order;
		sort_options.sortKey = key;

		array.sort((a: any, b: any) => {
			let aValue = key === 'USR_ORG' && a[key] ? a[key]?.ORG_LIBELLE : a[key];
			let bValue = key === 'USR_ORG' && b[key] ? b[key]?.ORG_LIBELLE : b[key];

			if (aValue < bValue) {
				return order === 'asc' ? -1 : 1;
			} else if (aValue > bValue) {
				return order === 'asc' ? 1 : -1;
			} else {
				return 0;
			}
		});
	}

	addOrEditAgency(_id: number = -1) {
		console.log("addOrEditAgency");

		// Hide all tooltips
		$('[data-toggle=\"tooltip\"]').tooltip('hide');

		let modal: any = {
			name: "modal-add-agency",
			data: {id: _id}
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	formatOriginalAdr(_adr: any) {
		if (_adr) {
			let virgule = (_adr.ADR_ADRESSE_1) ? ', ' : '';
			return _adr.ADR_ADRESSE_1 + virgule + _adr.ADR_CP + ' ' + _adr.ADR_VILLE + ', ' + _adr.PYS_CODE;
		}
		return null;
	}

	formatAdrComp(_param: string, adrListParams: any) {
		let objParam = adrListParams.filter((item: any) =>
			item.types[0] === _param
		);

		if (_param === 'country') return (objParam.length > 0) ? objParam[0].short_name : null;
		//console.log('objParam ------->', objParam);
		return (objParam.length > 0) ? objParam[0].long_name : null;
	}

	updateValidatorsAdrComplete(value: any, adrControl: any, _adr: any) {
		if (value === '') {
			// Si la valeur est une chaîne vide, supprimez l'adresse et mettre orgAdrControl à null
			_adr = (!_adr) ? new Adresse() : _adr;
			adrControl?.setValue(null);
			console.log("adrControl ==> ", adrControl);
			console.log("_adr ==> ", _adr);
			// Si la valeur est une chaîne vide, supprimez le validateur adresseValidator
			adrControl?.clearValidators();
			adrControl?.setValidators([]);
		} else {
			// Sinon, ajoutez le validateur adresseValidator
			adrControl?.setValidators([Validators.required, this.adresseValidator()]);
		}
		adrControl?.updateValueAndValidity();
	}

	googleAddressToAdresse(searchElementRef: any, _form: FormGroup, _address: Adresse) {
		console.log('_address', _address);
		//console.log('this.searchElementRef', searchElementRef);
		//console.log('this.searchElementRef.nativeElement', searchElementRef.nativeElement)
		let autocomplete = new google.maps.places.Autocomplete(searchElementRef.nativeElement, {
			componentRestrictions: {country: 'FR'}
		});
		autocomplete.addListener("place_changed", () => {
			this.ngZone.run(() => {
				console.log('this.agencyForm.get("adresseComplete")?.value', _form.get('adresseComplete')?.value)
				if (!_address === undefined) return;

				let place: google.maps.places.PlaceResult = autocomplete.getPlace();

				if (place.geometry === undefined || place.geometry === null) {
					console.log('place.geometry === undefined || place.geometry === null', place.geometry === undefined || place.geometry === null)
					return;
				}

				console.log('place ------> ', place);
				// console.log("this._address ==> ", this._address);
				let numRue = this.formatAdrComp('street_number', place.address_components) || '';
				let rue = this.formatAdrComp('route', place.address_components) || '';

				_address.ADR_ADRESSE_1 = (numRue && rue) ? numRue + ' ' + rue : numRue + rue;
				_address.ADR_CP = this.formatAdrComp('postal_code', place.address_components);
				_address.ADR_VILLE = this.formatAdrComp('locality', place.address_components);
				_address.PYS_CODE = this.formatAdrComp('country', place.address_components);
				console.log("_address-----", _address);
				if (_form) {
					_form.get('ORG_ADR')?.setValue(_address);
					_form.get('USR_ADR')?.setValue(_address);
					console.log("_form ==> ", _form);
					let adrControl = _form.get('USR_ADR');
					this.updateValidatorsAdrComplete(searchElementRef, adrControl, _address);
				}
			})
		})
	}

	isAdresseOk(_adresse: any) {
		// if(_adresseComplete == '') return true;
		if (!_adresse) return false;
		let isOk = false;
		isOk = !!(_adresse.ADR_CP && _adresse.ADR_VILLE && _adresse.PYS_CODE);
		console.log("isAdresseOk isOk ==> ", isOk);
		console.log("isAdresseOk _adresse ==> ", _adresse);
		return isOk;
	}

	adresseValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const isOk = this.isAdresseOk(control.value);
			return isOk ? null : {adresseIncomplete: true};
		};
	}

	returnIsReadOnly(item: any, userRole: number): boolean {
		//console.log("======================================",item, userRole)
		// Check if the item is read-only or if the user role is not included in the item roles
		return (item.readonly || (item?.roles && item?.roles?.length > 0 && item?.roles?.includes(userRole)));
	}

	objectIdNull(_obj: any, param_object: string) {
		return (_obj === null || _obj === undefined);
	}

	getMinusOrPlus(param: string, action: string, _form: FormGroup) {
		let control = _form.get(param);
		if (control) {
			let value = control.value;

			if (action == 'minus' && value == 0) return;

			if (action == 'minus') value--;
			else value++;

			control.setValue(value);
		}
	}

	onlyNumberInput(event: KeyboardEvent) {
		if (event.key && !/[\d]/.test(event.key)) {
			event.preventDefault();
		}
	}

	getErrorMessage(param: string, globalTxt: any, f: any) {
		//console.log("getErrorMessage param ==> ", param, f[param], f[param]?.valid);
		//console.log("getErrorMessage f[param]?.errors?.requiredTrue ==> ", f[param]?.errors?.requiredTrue);

		if (f[param]?.errors?.required) {
			if (param.indexOf('_ADR') != -1) return globalTxt.formFields.errorMsgAdrComplete;
			else if (param.indexOf('cgu') != -1) return globalTxt.formFields.errorMsgRequiredTrueCgu;
			else return globalTxt.formFields.errorMsg;
		} else if (f[param]?.errors?.adresseIncomplete) {
			return globalTxt.formFields.errorMsgAdrComplete;
		} else if (f[param]?.errors?.mustMatch) {
			if (param.indexOf('_NEW_CONFIRM') != -1) {
				return globalTxt.formFields.errorMsgConfirmPassword;
			}
		} else if (f[param]?.errors?.pattern) {
			//console.log(f[param]?.errors?.pattern)
			if (param.indexOf('_MOBILE') != -1 || param.indexOf('tel') != -1) {
				return globalTxt.formFields.errorMsgPhone;
			} else if (param.indexOf('_MDP') != -1) {
				return globalTxt.formFields.errorMsgPassword;
			} else if (param.indexOf('_EMAIL') != -1 || param.indexOf('email') != -1) {
				return globalTxt.formFields.errorMsgEmail;
			}
		} else if (f[param]?.errors?.maxSimu) {
			if (param.indexOf('_SIMU_TOTAL') != -1) {
				return globalTxt.formFields.errorMsgMaxSimu + ' ' + f[param].errors.maxSimu.maxAllowed;
			}
		}
		return '';
	}

	getPageJson(_path: any, _param: any) {
		let nameJson: any = "";
		let classList: any = "";

		if (_path.indexOf('?') != -1) {
			console.log("_path ==> ", _path);
			let match = _path.match(/\/?(\w+)\?/);
			_path = match ? match[1] : "";
		}

		switch (_path) {
			case ROUTES_PATHS.MON_COMPTE:
				nameJson = "txtMonCompte";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.ESTIMATIONS:
				nameJson = "txtEstimations";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.AGENTS:
				nameJson = "txtAgents";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.AGENCES:
				nameJson = "txtAgencies";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.CLIENTS:
				nameJson = "txtClients";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.TUTORIELS:
				nameJson = "txtTutoriels";
				classList = "small m-0";
				break;

			case ROUTES_PATHS.WELCOME:
				nameJson = "txtWelcome";
				classList = "color-white";
				break;

			case ROUTES_PATHS.CHOIX_RENOV:
				nameJson = "txtChoixRenov"
				classList = "small";
				break;

			case ROUTES_PATHS.CHOIX_RENOV_BIS:
				nameJson = "txtChoixRenovBis"
				classList = "small";
				break;

			case ROUTES_PATHS.BATIMENT:
				nameJson = "txtBatiment"
				classList = "small";
				break;

			case ROUTES_PATHS.PIECES:
				nameJson = "txtPieces"
				classList = "small";
				break;

			case ROUTES_PATHS.ESTIMATION_RAPIDE:
				nameJson = "txtEstimRapide"
				classList = "small";
				break;

			case ROUTES_PATHS.PIECE_PAR_PIECE:
				nameJson = "txtPieceParPiece"
				classList = "small";
				break;

			case ROUTES_PATHS.PRODUITS:
				nameJson = "txtProduits"
				classList = "small";
				break;

			case ROUTES_PATHS.INSCRIPTION:
				nameJson = "txtInscription"
				classList = "small";
				break;

			case ROUTES_PATHS.TRANSACTION:
				nameJson = "txtTransaction"
				classList = "small";
				break;

			case ROUTES_PATHS.PARTENAIRES:
				nameJson = "txtPartenaires"
				classList = "small";
				break;

			case ROUTES_PATHS.ALL_USERS:
				nameJson = "txtAllUsers"
				classList = "small";
				break;

			case ROUTES_PATHS.CONTACT_EXTERNE:
				nameJson = "txtContactExterne"
				classList = "small";
				break;

			default:
				console.warn("getPageJson settings is missing !");
				break;

		}
		return (_param == "name_json") ? Promise.resolve(nameJson) : (_param == "class_list") ? Promise.resolve(classList) : "";
	}

	getNameJson = async () => {
		try {
			let nameJson = await this.getPageJson(this.router.url.split('/')[1], "name_json");
			console.log("getNameJson() ==> ", nameJson);

			this.dataToolsService.setNameJson(nameJson);
		} catch (error) {
			console.error("Error getNameJson() ==> ", error);
		}
	}

	getClassesList = async () => {
		try {
			let classList = await this.getPageJson(this.router.url.split('/')[1], "class_list");
			this.dataToolsService.setClassList(classList);
		} catch (error) {
			console.error("Error getClassesList() ==> ", error);
		}
	}

	getTxtSwitchModal(_nameModal: any) {
		let nameObjTxt = "";

		switch (_nameModal) {
			case 'modal-admin-add-user':
				nameObjTxt = "adminAddUser";
				break;
			case 'modal-add-user':
				nameObjTxt = "addUser";
				break;
			case 'modal-add-agency':
				nameObjTxt = "addAgency";
				break;
			case 'modal-meubles-cuisine':
				nameObjTxt = "meublesCuisine";
				break;
			case 'modal-recopier-choix':
				nameObjTxt = "recopierChoix";
				break;
			case 'modal-autres-finitions':
				nameObjTxt = "autresFinitions";
				break;
			case 'modal-reglages':
				nameObjTxt = "reglages";
				break;
			case 'modal-scenario-nrj':
				nameObjTxt = "scenarios";
				break;
			case 'modal-loader-estimation':
				nameObjTxt = "loaderEstimation";
				break;
			case 'modal-inscription-special':
				nameObjTxt = "inscription";
				break;

			default:
		}

		return nameObjTxt;
	}

	getNameJsonInModal = async (_nameModal: any) => {
		try {
			let nameModalJson = await this.getTxtSwitchModal(_nameModal);
			this.dataToolsService.setModalNameJson(nameModalJson);
		} catch (error) {
			console.error("Error getNameJsonInModal() ==> ", error);
		}
	}

	//goToNewTab(path: any, objParams: any) {
	//  const url = this.router.serializeUrl(this.router.createUrlTree([path], { queryParams: objParams }));
	//  window.open(url, '_blank');
	//}

	//logOut() {
	//  this.confirmDialogService.confirmThis("", "Êtes-vous sûr(e) de vouloir vous déconnecter ?", "confirm", "supp_com", () => {
	//    //Suppression du UserHash
	//    if (localStorage != null) localStorage.clear();
	//    //Rédirection vers la page de login
	//    this.router.navigate(['/']);
	//  }, () => { return; })
	//}

	getIfSessionExists() {
		let tokenEnCours = JSON.parse(localStorage.getItem("token")!);
		console.log("tokenEnCours ==> ", tokenEnCours);

		let isSessionEnCours = (tokenEnCours) ? true : false;

		if (localStorage && !isSessionEnCours) localStorage.clear();

		return isSessionEnCours;
	}

	getLabel(id: number, array: any) {
		//console.log(id, array);

		let libelle = array.filter((item: any, index: number) => {
			return (item.id == id);
		});

		return (!libelle[0]) ? "" : libelle[0].label;
	}

	// User BO Functions
	addOrEditUser(_id: number, _role: number) {
		console.log("addAgent _role ==> ", _role);

		// Hide all tooltips
		$('[data-toggle=\"tooltip\"]').tooltip('hide');

		let modal: any = {
			name: "modal-add-user",
			data: {id: _id, role: _role}
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	// User BO Functions
	addOrEditUserByAdmin(_id: number) {
		// Hide all tooltips
		$('[data-toggle=\"tooltip\"]').tooltip('hide');

		let modal: any = {
			name: "modal-admin-add-user",
			data: {id: _id}
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	sendPasswordByEmail(_email: string, _modalsTexts: any) {
		this.confirmDialogService.confirmThis(
			"", //title
			_modalsTexts.modalResetAndSendPassword, //text
			"confirm",
			"",
			() => {
				this.sendPasswordEmailConfirm(_email, _modalsTexts);
			},
			() => {}
		);
	}

	sendPasswordEmailConfirm(_email: string, _modalsTexts:any) {
		this.apiToolsService.forgotPassword(_email).subscribe(
			(res: any) => {
				console.log("sendPasswordEmailConfirm ==> ", res);
				this.confirmDialogService.confirmThis(
					"",
					_modalsTexts.modalSendedPassword,
					"alert",
					"",
					() => {
					},
					() => {
					});
			},
			error => {
				console.log("error ==> ", error);
				this.confirmDialogService.confirmThis('', error.error.Message, 'alert', '', () => {
				}, () => {
				});
			});
	}

	deleteUser(_id: number, _texteModalConfirm: string) {
		console.log("deleteAgent ==> ", _id);
		this.confirmDialogService.confirmThis(
			"", //title
			_texteModalConfirm, //text
			"confirm", //type
			"suppression", //template
			() => {
				//  Call the delete function
				this.delUserDtoAlt(_id);
			}, // function to delete item
			() => {
			});
	}

	delUserDtoAlt(_userId: number) {
		this.apiToolsService.delUserDtoAlt(_userId).subscribe(
			(res: any) => {
				console.log("delUserDtoAlt ==> ", res);
				this.confirmDialogService.confirmThis(
					"", //title
					"L'utilisateur a bien été supprimé", "alert", "",
					() => {
						location.reload();
					},
					() => {
					});
			},
			error => {
				console.log("error ==> ", error);
				this.confirmDialogService.confirmThis('', error.error.Message, 'alert', '', () => {
				}, () => {
				});
			});
	}

	addLightOrSubtractLight(color: any, percent: any, theme: any) {
		let _theme: any = (theme == "darken") ? 0 : 255;

		let cc_light = parseInt(color, 16) + percent;
		let cc_dark = parseInt(color, 16) - percent;
		let cc = (theme == "darken") ? cc_dark : cc_light;

		let c_light = (cc > _theme) ? _theme : (cc);
		let c_dark = (cc < _theme) ? _theme : (cc);
		let c = (theme == "darken") ? c_dark : c_light;

		c = (c.toString(16).length > 1) ? c.toString(16) : `0${c.toString(16)}`;
		return c;
	}

	lightenOrDarken(color: any, _amount: any, theme: any) {
		color = (color.indexOf("#") >= 0) ? color.substring(1, color.length) : color;
		let nb: any = (255 * _amount) / 100;
		let amount: any = parseInt(nb);
		return color = `#${this.addLightOrSubtractLight(color.substring(0, 2), amount, theme)}${this.addLightOrSubtractLight(color.substring(2, 4), amount, theme)}${this.addLightOrSubtractLight(color.substring(4, 6), amount, theme)}`;
	}

	bodySetDefaultColor(default_color: string) {
		let default_color_lighten = this.lightenOrDarken(default_color, 10, 'lighten');
		let default_color_darken = this.lightenOrDarken(default_color, 30, 'darken');

		document.body.style.setProperty("--default-color", default_color);
		document.body.style.setProperty("--default-color-lighten", default_color_lighten);
		document.body.style.setProperty("--default-color-darken", default_color_darken);
	}

	bodySetDefaultFont(default_font: string) {
		document.body.style.setProperty("--default-font", default_font);
	}

	bodySetSecondaryFont(secondary_font: string) {
		document.body.style.setProperty("--secondary-font", secondary_font);
	}

	bodySetOtherFont(other_font: string) {
		document.body.style.setProperty("--other-font", other_font);
	}

	getSettings() {
		// ==> Get the default color from the settings
		this.getParamSettings('default_color').subscribe((color: string) => {
			this.bodySetDefaultColor(color);
		});

		// ==> Get the default font from the settings
		this.getParamSettings('default_font').subscribe((font: string) => {
			this.bodySetDefaultFont(font);
		});

		// ==> Get the secondary font from the settings
		this.getParamSettings('secondary_font').subscribe((font: string) => {
			this.bodySetSecondaryFont(font);
		});

		// ==> Get the other font from the settings
		this.getParamSettings('other_font').subscribe((font: string) => {
			this.bodySetOtherFont(font);
		});
	}

	getParamSettings(_param: string): Observable<any> {
		const settingObj = settings[this.returnObjectSwitchRefId()];
		return new BehaviorSubject(settingObj[_param as keyof typeof settingObj]).asObservable();
	}

	getClassWitheTextInSurligne() {
		// ==> Add the class 'text-white' to the txt-surligne element in various sites
		let site_name = this.returnObjectSwitchRefId();
		console.log("site_name", site_name);
		switch (site_name) {
			case SiteKeyEnum.LADRESSE:
			case SiteKeyEnum.SELOGER:
			case SiteKeyEnum.LFIMMO:
			case SiteKeyEnum.CADASTRE:
			case SiteKeyEnum.INNOVIA:
			case SiteKeyEnum.CAPIFRANCE:
			case SiteKeyEnum.WEINVESTAGENT:
			case SiteKeyEnum.WEINVESTCLIENT:
			case SiteKeyEnum.LOISELETDAIGREMONT:
				let txtsurligne = document.querySelectorAll('.txt-surligne');
				console.log("site_name txtsurligne", txtsurligne);
				txtsurligne.forEach(element => {
					element.classList.add('color-white');
				});
				break;
			default:
				break;
		}
	}

	returnObjectSwitchRefId(): keyof typeof settings {
		const tokenEnCours = JSON.parse(localStorage.getItem("token")!);
		const refId = tokenEnCours?.refId;

		// Recherche dynamique de la clé correspondant au refId
		const matchedKey = Object.keys(settings).find(
			(key) => settings[key as keyof typeof settings].ref_id === refId
		);

		// Retourne la clé trouvée, ou 'koutravo' par défaut
		return (matchedKey as keyof typeof settings) || SiteKeyEnum.KOUTRAVO;
	}

	getURLParameter(): any {
		let queryString = this.router.url.split('?')[1];
		let params = new URLSearchParams(queryString);

		let result: any = {};
		params.forEach((value, key) => {
			result[key] = value;
		});

		console.log(result);

		return result;
	}

	async goToStripe(productId: string, priceId: string) {
		if (!productId || !priceId) return;

		if (productId == "prod_RefererFree") {
			this.router.navigate([ROUTES_PATHS.CHOIX_RENOV]);
			return;
		}

		const stripe = await this.stripePromise;

		this.apiToolsService.runStripeCheckoutProcess(productId, priceId).subscribe(async (session: any) => {
			console.log("session runStripeCheckoutProcess ==> ", session);
			await stripe?.redirectToCheckout({sessionId: session.id});
		});
	}

	getRenovationKeyByValue(value: string): RenovationKey | undefined {
		return (Object.keys(RENOVATION_MAP) as RenovationKey[]).find(
			key => RENOVATION_MAP[key] === value
		);
	}

	getRenovationValue(renovation: string): number {
		const renovationKey = this.getRenovationKeyByValue(renovation);
		return renovationKey ? RENOVATION_VALUE_MAP[renovationKey] : -1;
	}

	stringListToObjectList(list: string[], labelKey: string): Record<string, any>[] {
		if (!Array.isArray(list)) return [];
		return list.map(el => ({ [labelKey]: el }));
	}

	hasPermission(permission: CodePermissionEnum): boolean{
		let permissions: string[] = [];
		try {
			permissions = JSON.parse(localStorage.getItem("token") ?? "null")?.permissions ?? [];
		} catch {
			permissions = [];
		}
		return permissions.includes(permission);
	}

	denyAccessToMyAccountSpace(): Observable<boolean> {
		return this.getParamSettings('use_permissions').pipe(
			take(1),
			switchMap((isUsePermission: boolean) => {
				if (isUsePermission) {
					// Refus d'accès si la permission est absente
					return of(!this.hasPermission(CodePermissionEnum.Header_MyAccount_Access));
				}

				return this.getParamSettings('bo_showed').pipe(
					take(1),
					map((is_showed: boolean) => !is_showed)
				);
			})
		);
	}

}


